export default "__VITE_ASSET__BuRC1zfj__"